import FixedButton from "../component/FixedButton"
import Hero from "../component/Hero"

const Home = () => {
  return (
    <div>
    <Hero/>
    </div>
  )
}

export default Home
